import React from 'react';
import { Calendar, Clock, History } from 'lucide-react';

/**
 * Компонент для ввода текущего статуса кредита
 */
const CurrentLoanStatusSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <History className="w-5 h-5 mr-2 text-blue-500" />
        Текущий статус кредита
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Текущая дата */}
        <div>
          <label htmlFor="currentDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-blue-500" />
            Текущая дата
          </label>
          <input
            type="date"
            id="currentDate"
            name="currentDate"
            value={formData.currentDate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.currentDate ? 'input-error' : ''}`}
          />
          {errors.currentDate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.currentDate}
            </p>
          )}
        </div>

        {/* Количество сделанных платежей */}
        <div>
          <label htmlFor="paymentsMade" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-blue-500" />
            Выполнено платежей
          </label>
          <input
            type="text"
            id="paymentsMade"
            name="paymentsMade"
            value={formData.paymentsMade}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.paymentsMade ? 'input-error' : ''}`}
            placeholder="Сколько месяцев уже оплачено"
          />
          {errors.paymentsMade && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.paymentsMade}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-blue-50 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <History className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Информация о текущем статусе кредита
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Укажите, сколько ежемесячных платежей вы уже выполнили по графику. 
              Это важно для корректного расчета оставшейся суммы основного долга и 
              определения оптимального момента для начала досрочного погашения.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentLoanStatusSection;